import { useEffect, useState, useRef } from "react";
import { Checkbox, Column, Icon, Label, Panel, Row, Select } from "../../components";
import DocuMateRefiService, {
  getCarrierDropdownOptions,
  getImpoundsDropdownOptions,
  getLoanPositionDropdownOptions,
  getRequestTypeDropdownOptions,
  getRefiTodoList,
} from "./DocuMateRefiService";
import { useHistory, useLocation } from "react-router-dom";
import { RefiDocumentDto } from "../model/RefiDocumentDto";
import DocViewer from "../shared/components/DocViewer";
import { SelectOption } from "../../shared/components/input";
import * as documateLabel from "../shared/util/docuMateLabel";
import * as constant from "../shared/util/docuMateConstant";
import "./RefiProcessing.scss";
import { toast } from "react-toastify";
import { FloatingLabel, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { updateRefiDocumentStatus } from "../services/DocuMateAPI";
import Logger from "../../shared/services/Logger";

export const initialDocument: RefiDocumentDto = {
  refiRequestId: "",
  uploadedFileName: "",
  documentDescription: "",
  dateInitiated: "",
  dateAvailable: "",
  isLocked: false,
  requestType: "",
  vesting: "",
  policyNbr: "",
  carrierName: "",
  custFirstName: "",
  custLastName: "",
  writingCompanyName: "",
  vestingAddressLine1: "",
  vestingAddressLine2: "",
  vestingAddrCity: "",
  vestingAddrState: "",
  vestingAddrZipCode: "",
  loanNumber: "",
  loanPosition: "",
  impound: "",
  mortgageeName: "",
  mortgageeClause: "",
  mortgageeNameAddressLine1: "",
  mortgageeNameAddressLine2: "",
  mortgageeNameAddrCity: "",
  mortgageeNameAddrState: "",
  mortgageeNameAddrZipCode: "",
  requestorName: "",
  requestorEmail: "",
  isBusiness: false
};

const RefiProcessing = () => {
  const location = useLocation();
  const state = location.state as { id: string; fileName: string, lockedDocs: [], viewOnly?: boolean };
  // Opened from the todo list while another user holds the document.
  const isViewOnly = state?.viewOnly === true;
  const urlParam = new URLSearchParams(location.search);
  const [fileName, setFileName] = useState(state?.fileName);
  const [id, setId] = useState(state?.id || urlParam.get("id"));
  const refiService = new DocuMateRefiService();
  const [currentDocument, setCurrentDocument] = useState<RefiDocumentDto>(initialDocument);
  const [emailPdf, setEmailPdf] = useState<any>(null);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [requestTypeOptions] = useState<SelectOption[]>(
    getRequestTypeDropdownOptions()
  );
  const [vestingOptions, setVestingOptions] = useState<SelectOption[]>([]);
  const [carrierOptions] = useState<SelectOption[]>(
    getCarrierDropdownOptions()
  );
  const [statesList, setStatesList] = useState<SelectOption[]>([]);
  const [impoundsOptions] = useState<SelectOption[]>(
    getImpoundsDropdownOptions()
  );
  const [loanPositionOptions] = useState<SelectOption[]>(
    getLoanPositionDropdownOptions()
  );
  const [formValidation, setFormValidation] = useState<any>({});
  const [docViewerOpen, setDocViewerOpen] = useState(false);
  const [showDropdownButtons, setShowDropdownButtons] = useState(false);
  const [NewStatus] = useState('New');
  const [InProgressStatus] = useState('InProgress');

  const firstControlRef = useRef(null);
  const closeButtonRef = useRef(null);

  /// Method to intialize component.
  let initializeComponent = async (id: string) => {
    // States and vesting dropdowns do not change between documents, so load
    // them only once and reuse them when advancing to the next document.
    if (statesList.length === 0) {
      let states = await refiService.getStatesList();
      setStatesList(states);
    }
    if (vestingOptions.length === 0) {
      let vesting = await refiService.getVestingList();
      setVestingOptions(vesting);
    }
    try {
      let document = await refiService.fetchRefiDocumentFields(id);
      console.log('Fetched document', document);
      setCurrentDocument(document);
      fetchRefiDocument(id);
      setIsLoading(false);
    }
    catch (error) {
      toast.error('Failed to fetch the document fields. Please try again later.', {
      position: toast.POSITION.TOP_RIGHT,
      });
      navigateToTodoList();
    }
  };

  let fetchRefiDocument = async (docId: string) => {
    // Clear any previously loaded document so a failed/slow fetch never leaves
    // the prior document's content in the viewer.
    setEmailPdf(null);
    setDocViewerOpen(false);
    try {
      let response = await refiService.fetchRefiDocument(docId);
      if (response.status === 200) {
      let email = await response.data;
      setEmailPdf(email);
      setDocViewerOpen(true);
      }
    }
    catch (error) {
      toast.error('Failed to fetch the document from blob. Please try again later.', {
      position: toast.POSITION.TOP_RIGHT,
      });
    }
  }

  useEffect(() => {
    setIsLoading(true);
      initializeComponent(id);
  }, [id]);

  const navigateToTodoList = () => {
    history.push("/documate-refi");
  };

  // After an approve/reject, fetch a fresh Refi list and open the first available
  // document (one that is not currently being worked on by anyone). If none is
  // available, fall back to the Refi todo list.
  const openNextAvailableDocument = async () => {
    try {
      let refiList = await getRefiTodoList();
      // if another user took the document first, so try the next one.
      for (const nextDocument of refiList.filter((doc) => doc.status !== InProgressStatus)) {
        const res = await updateRefiDocumentStatus(nextDocument.refiRequestId, InProgressStatus);
        if (res.data !== false) {
          setFormValidation({});
          setFileName(nextDocument.fileName);
          setId(nextDocument.refiRequestId);
          return;
        }
      }
      navigateToTodoList();
    } catch (error) {
      navigateToTodoList();
    }
  };

      // const fetchDocument = async (docId) => {
      //     try {
      //         const blob = await getRefiDocument(docId);
      //         const blobUrl = URL.createObjectURL(blob);
      //         console.log('blobUrl', blobUrl);
      //         setCurrentEmail(blobUrl);
      //         console.log('currentEmail', currentEmail);
      //         // const a = document.createElement('a');
      //         // a.href = blobUrl;
      //         // a.download = {fileName} + '.eml';
      //         // document.body.appendChild(a);
      //         // a.click();
      //         // document.body.removeChild(a);

      //         // setTimeout(() => {
      //         //   const emailWindow = window.open(blobUrl, '_blank');
      //         //   if(!emailWindow) {
      //         //     toast.info('The email has been downloaded. Please open it manually or allow popups to auto-open.');
      //         //   }
      //         // }, 1000);
  
      //     } catch (error) {
      //         console.error('Error fetching the PDF file:', error);
      //         toast.error('Error fetching the email. Please try again later.');
      //     }
      // };
  
      // useEffect(() => {
      //     fetchDocument(id);
  
      //     // Cleanup function to revoke blob URL
      //     return () => {
      //         if (document) {
      //             URL.revokeObjectURL(currentEmail);
      //         }
      //     };
      // }, [id]);

  const onEntityFieldChange = (
    propName: string,
    value: string | Date | boolean
  ) => {
    setCurrentDocument({
      ...currentDocument,
      [propName]: value,
    });
  };

  const onApproveDocument = async (id: string) => {
    // save state to the db
    try {
      currentDocument.refiRequestId = id;
      let validationError = refiService.validateRefiDocument(currentDocument);
      setFormValidation(validationError);
      if (Object.keys(validationError).length > 0) {
        toast.warn(constant.DOCUMENT_FORM_VALIDATION_ERROR_MESSAGE, {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      } else {
        await refiService.approveRefiDocument(currentDocument);
        toast.success(constant.DOCUMENT_APPROVED, {
          position: toast.POSITION.TOP_RIGHT,
        });
        await openNextAvailableDocument();
      }
    } catch (error) {
      console.log(error);
      if (error && error.data && error.data.errors) {
        const errors = error.data.errors;
        for (let key in errors) {
          if (errors.hasOwnProperty(key)) {
            toast.error(`Unable to approve the document: ${errors[key][0]}`, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      } else {
        toast.error(constant.REFI_APPROVAL_ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
    return;
  };

    const rejectDocument = async (id: string) => {
        try {
            currentDocument.refiRequestId = id;
            let validationError = refiService.validateRejectRefiDocument(currentDocument);
            setFormValidation(validationError);
            if (Object.keys(validationError).length > 0) {
                toast.warn(constant.DOCUMENT_FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            } else {
                console.log('currentDocument for rejection', currentDocument);
                let rejectReponse = await refiService.rejectRefiDocument(currentDocument);
                if (rejectReponse.status !== 200) {
                    toast.error(constant.DOCUMENT_REJECTED_ERROR, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return;
                }
                else if (rejectReponse.status === 200 && rejectReponse.data === false) {
                    toast.warning(constant.REJECT_EMAIL_SEND_ERROR, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
                else {
                    toast.success(constant.DOCUMENT_REJECTED, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
                await openNextAvailableDocument();
            }
        } catch (error) {
            Logger.logError(error.toString()); 
            toast.error(constant.DOCUMENT_REJECTED_ERROR, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        return;
    }

  const handleCloseDocument = (id: string) => {
    // A view-only user doesn't hold the document, so there is nothing to release.
    if (isViewOnly) {
      navigateToTodoList();
      return;
    }
    updateRefiDocumentStatus(id, NewStatus).then((res) => {
      if(res.status !== 200) {
        toast.error('Failed to close the document. Please try again later.', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      else {
        navigateToTodoList();
      }
      return;
    }).catch(() => {
      toast.error('Failed to close the document. Please try again later.', {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
  }

  const handleDocViewerClose = () => {
    // DocViewerOpen(false);
  };

  const toggleDropwdownButtons = (event) => {
    event.preventDefault();
    setShowDropdownButtons(!showDropdownButtons);
  };

  const CloseButtonWithDropdownOptions = (
    <>
      <div className="close-btn-div">
        <Button
          className="btn btn-primary bt-main-action"
          key="filter"
          onClick={() => navigateToTodoList()}
          tabIndex={21}
          id="closeRefi"
          disabled={false}
          outlined={true}
          // icon="down-arrow"
          // iconLocation="right"
        >
          {documateLabel.CLOSE_DOCUMENT}
        </Button>
        <Button
          className="btn btn-primary bt-main-action"
          key="filter"
          onClick={(event) => toggleDropwdownButtons(event)}
          tabIndex={21}
          id="toggleCloseButtons"
          disabled={false}
          outlined={true}
        >
          {showDropdownButtons ? (
            <span>
              <Icon icon="up-arrow" />
            </span>
          ) : (
            <span>
              <Icon icon="down-arrow" />
            </span>
          )}
        </Button>
      </div>
      <div className="close-btn-div2">
        {showDropdownButtons && (
          <div className="dropdown-btn-grp">
            <Button
              className=""
              key="filter"
              onClick={() => navigateToTodoList()}
              tabIndex={21}
              id="closeAndNextRefi"
              disabled={false}
              // outlined={true}
            >
              {documateLabel.CLOSE_NEXT_DOCUMENT}
            </Button>
            <Button
              className=""
              key="filter"
              onClick={() => navigateToTodoList()}
              tabIndex={21}
              id="closeAndEndRefi"
              disabled={false}
              // outlined={true}
            >
              {documateLabel.CLOSE_END_AUTOPROCESS}
            </Button>
          </div>
        )}
      </div>
    </>
  );

  return (
    <>
      {/* <Label title="DocuMateRefiProcessing" text={scanId} className='documateHeader'></Label> */}
      {isLoading && <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>Fetching Document...</div>}
      {!isLoading && (
        <div className="parent-container">
          <div className="refiPanel">
            <Panel title={documateLabel.REFI_PROCESSING_LABELS.reiPanel}>
              <Row>
                <Column lg={6} md={6}>
                  <Select
                    id="RequestType"
                    controlId="RequestType"
                    className="mb-3"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.requestType}
                        {/* <span className="text-danger ms-1">*</span> */}
                      </>
                    }
                    options={requestTypeOptions}
                    sortOptions={false}
                    defaultSelected={requestTypeOptions.filter(
                      (option) => option.value === currentDocument.requestType
                    )}
                    onChange={(values) =>
                      onEntityFieldChange("requestType", values[0] as string)
                    }
                    tabIndex={1}
                    isInvalid={formValidation["requestType"]?.isValid == false}
                    invalidWarning={formValidation["requestType"]?.warningText}
                    isRequired={true}
                    ref={firstControlRef}
                    onKeyDown={(e) => {
                    if (e.key == "Tab" &&  e.shiftKey) {
                      closeButtonRef.current.focus();
                      e.preventDefault();
                    }
                }}
                  />
                </Column>
                <Column lg={6} md={6}>
                  <Select
                    id="Vesting"
                    controlId="Vesting"
                    className="mb-3"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.vesting}
                        {/* <span className="text-danger ms-1">*</span> */}
                      </>
                    }
                    options={vestingOptions}
                    defaultSelected={vestingOptions.filter(
                      (option) => option.value === currentDocument.vesting
                    )}
                    onChange={(values) =>
                      onEntityFieldChange("vesting", values[0] as string)
                    }
                    tabIndex={2}
                    // isInvalid={formValidation["vesting"]?.isValid == false}
                    // invalidWarning={formValidation["vesting"]?.warningText}
                    // isRequired={true}
                  />
                </Column>
              </Row>
              <Row>
                <Column lg={6} md={6}>
                  <FloatingLabel
                    controlId="policyNbr"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.policyNumber}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="policyNbr"
                      value={currentDocument.policyNbr ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "policyNbr",
                          event.currentTarget.value
                        )
                      }
                      // disabled={!isEditable}
                      required={true}
                      tabIndex={3}
                      maxLength={25}
                      isInvalid={formValidation["policyNbr"]?.isValid == false}
                    />
                    {formValidation["policyNbr"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["policyNbr"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={6} md={6}>
                  <Select
                    id="carrierName"
                    controlId="carrierName"
                    className="mb-3"
                    label={
                      <>
                      {documateLabel.REFI_PROCESSING_LABELS.carrier}
                      {/* <span className="text-danger ms-1">*</span> */}
                      </>
                    }
                    options={carrierOptions}
                    defaultSelected={carrierOptions.filter(
                      (option) => option.value === currentDocument.carrierName
                    )}
                    onChange={(values) =>
                      onEntityFieldChange("carrierName", values[0] as string)
                    }
                    tabIndex={4}
                    isInvalid={formValidation["carrierName"]?.isValid == false}
                    invalidWarning={formValidation["carrierName"]?.warningText}
                    isRequired={true}
                  />
                </Column>
              </Row>
            </Panel>
            <Panel title={documateLabel.REFI_PROCESSING_LABELS.customerPanel}>
              <Row>
                <Column lg={12} md={12}>
                    <Checkbox
                    id="isBusiness"
                    label={documateLabel.REFI_PROCESSING_LABELS.business}
                    className="mb-3"
                    name="business"
                    inline={true}
                    disabled={false}
                    onChange={(event) => {
                      onEntityFieldChange(
                        "isBusiness",
                        event.currentTarget.checked
                      );
                    }}
                    tabIndex={5}
                    // className,
                    // style,
                    // labelClassName,
                    // labelStyle,
                    // checked,
                    // checkboxStyle,
                    />
                </Column>
              </Row>
              <Row>
                <Column lg={6} md={6}>
                  <FloatingLabel
                    controlId="firstName"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.firstName}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="CustFirstName"
                      value={currentDocument.custFirstName ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "custFirstName",
                          event.currentTarget.value
                        )
                      }
                      // disabled={!isEditable}
                      required={true}
                      tabIndex={6}
                      maxLength={50}
                      isInvalid={formValidation["custFirstName"]?.isValid == false}
                    />
                    {formValidation["custFirstName"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["custFirstName"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                {/* <Column lg={4} md={4}>
                  <FloatingLabel
                    controlId="middleName"
                    label={documateLabel.REFI_PROCESSING_LABELS.middleName}
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="middleName"
                      value={currentDocument.middleName1 ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "middleName1",
                          event.currentTarget.value
                        )
                      }
                      tabIndex={1}
                    />
                  </FloatingLabel>
                </Column> */}
                <Column lg={6} md={6}>
                  <FloatingLabel
                    controlId="custLastName"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.lastName}
                        {!currentDocument.isBusiness ? <span className="text-danger ms-1">*</span> : null}
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="custLastName"
                      value={currentDocument.custLastName ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "custLastName",
                          event.currentTarget.value
                        )
                      }
                      required={!currentDocument.isBusiness}
                      tabIndex={7}
                      maxLength={50}
                      isInvalid={!currentDocument.isBusiness && formValidation["custLastName"]?.isValid == false}
                    />
                    {!currentDocument.isBusiness && formValidation["custLastName"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["custLastName"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
              </Row>
              {/* <Row>
                <Column lg={8} md={8}>
                  <FloatingLabel
                    controlId="writingCompanyName"
                    label={
                    <>
                    {documateLabel.REFI_PROCESSING_LABELS.companyName}
                    <span className="text-danger ms-1">*</span>
                    </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="writingCompanyName"
                      value={currentDocument.writingCompanyName ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "writingCompanyName",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={1}
                      maxLength={100}
                      isInvalid={
                        formValidation["writingCompanyName"]?.isValid == false
                      }
                    />
                    {formValidation["writingCompanyName"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["writingCompanyName"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
              </Row> */}
              <Row>
                <Column lg={8} md={8}>
                  <FloatingLabel
                    controlId="vestingAddressLine1"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.propAddress}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="vestingAddressLine1"
                      value={currentDocument.vestingAddressLine1 ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "vestingAddressLine1",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={8}
                      maxLength={36}
                      isInvalid={formValidation["vestingAddressLine1"]?.isValid == false}
                    />
                    {formValidation["vestingAddressLine1"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["vestingAddressLine1"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={4} md={4}>
                  <FloatingLabel
                    controlId="vestingAddressLine2"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.addressLine2}
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="vestingAddressLine2"
                      value={currentDocument.vestingAddressLine2 ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "vestingAddressLine2",
                          event.currentTarget.value
                        )
                      }
                      tabIndex={9}
                      maxLength={36}
                    />
                  </FloatingLabel>
                </Column>
              </Row>
              <Row>
                <Column lg={3} md={3}>
                  <FloatingLabel
                    controlId="vestingAddrCity"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.city}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="vestingAddrCity"
                      value={currentDocument.vestingAddrCity ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "vestingAddrCity",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={10}
                      maxLength={23}
                      isInvalid={formValidation["vestingAddrCity"]?.isValid == false}
                    />
                    {formValidation["vestingAddrCity"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["vestingAddrCity"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={5} md={5}>
                  <Select
                    id="vestingAddrState"
                    controlId="vestingAddrState"
                    className="mb-3"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.state}
                        {/* <span className="text-danger ms-1">*</span> */}
                      </>
                    }
                    options={statesList}
                    defaultSelected={statesList.filter(
                      (option) => option.value === currentDocument.vestingAddrState
                    )}
                    onChange={(values) =>
                      onEntityFieldChange("vestingAddrState", values[0] as string)
                    }
                    tabIndex={11}
                    isInvalid={formValidation["vestingAddrState"]?.isValid == false}
                    invalidWarning={formValidation["vestingAddrState"]?.warningText}
                    isRequired={true}
                  />
                </Column>
                <Column lg={4} md={4}>
                  <FloatingLabel
                    controlId="vestingAddrZipCode"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.zip}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="vestingAddrZipCode"
                      value={currentDocument.vestingAddrZipCode ?? ""}
                      onChange={(event) => {
                        let value = event.currentTarget.value.replace(/[^0-9]/g, "");
                        if (value.length > 5) {
                          value = value.slice(0, 5) + '-' + value.slice(5, 9);
                        }
                        onEntityFieldChange("vestingAddrZipCode", value);
                      }}
                      required={true}
                      maxLength={10}
                      tabIndex={12}
                      isInvalid={formValidation["vestingAddrZipCode"]?.isValid == false}
                    />
                    {formValidation["vestingAddrZipCode"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["vestingAddrZipCode"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
              </Row>
            </Panel>
            <Panel title={documateLabel.REFI_PROCESSING_LABELS.mortgageePanel}>
              <Row>
                <Column lg={3} md={3}>
                  <FloatingLabel
                    controlId="loanNumber"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.loanNumber}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="LoanNumber"
                      value={currentDocument.loanNumber ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "loanNumber",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={13}
                      isInvalid={formValidation["loanNumber"]?.isValid == false}
                      maxLength={16}
                    />
                    {formValidation["loanNumber"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["loanNumber"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={5} md={5}>
                  <Select
                    id="loanPosition"
                    controlId="loanPosition"
                    className="mb-3"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.loanPosition}
                        {/* <span className="text-danger ms-1">*</span> */}
                      </>
                    }
                    options={loanPositionOptions}
                    defaultSelected={loanPositionOptions.filter(
                      (option) => option.value === currentDocument.loanPosition
                    )}
                    onChange={(values) =>
                      onEntityFieldChange("loanPosition", values[0] as string)
                    }
                    tabIndex={14}
                    isInvalid={formValidation["loanPosition"]?.isValid == false}
                    invalidWarning={formValidation["loanPosition"]?.warningText}
                    isRequired={true}
                  />
                </Column>
                <Column lg={4} md={4}>
                  <Select
                  id="impound"
                  controlId="impound"
                  className=""
                  label={
                    <>
                    {documateLabel.REFI_PROCESSING_LABELS.impounds}
                    {/* <span className="text-danger ms-1">*</span> */}
                    </>
                  }
                  options={impoundsOptions}
                  sortOptions={false}
                  defaultSelected={impoundsOptions.filter(
                    (option) => option.value === currentDocument.impound
                  )}
                  onChange={(values) =>
                    onEntityFieldChange("impound", values[0] as string)
                  }
                  tabIndex={15}
                  isInvalid={formValidation["impound"]?.isValid == false}
                  invalidWarning={formValidation["impound"]?.warningText}
                  isRequired={true}
                  />
                </Column>
              </Row>
              <Row>
                <Column lg={8} md={8}>
                  <FloatingLabel
                    controlId="mortgageeName"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.mortagageeName}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="mortgageeName"
                      value={currentDocument.mortgageeName ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "mortgageeName",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={16}
                      maxLength={80}
                      isInvalid={
                        formValidation["mortgageeName"]?.isValid == false
                      }
                    />
                    {formValidation["mortgageeName"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["mortgageeName"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
              </Row>
              <Row>
                <Column lg={8} md={8}>
                  <FloatingLabel
                    controlId="mortgageeClause"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.mortgageeClause}
                      </>
                    }
                    className={"mb-3"}
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="mortgageeClause"
                      value={currentDocument.mortgageeClause ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "mortgageeClause",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={17}
                      maxLength={80}
                      // isInvalid={
                      //   formValidation["mortgageeClause"]?.isValid == false
                      // }
                    />
                    {/* {formValidation["mortgageeClause"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["mortgageeClause"]?.warningText}
                      </Form.Control.Feedback>
                    )} */}
                  </FloatingLabel>
                </Column>
              </Row>
              <Row>
                <Column lg={8} md={8}>
                  <FloatingLabel
                    controlId="mortgageeNameAddressLine1"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.mortgageeAddress}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="mortgageeNameAddressLine1"
                      value={currentDocument.mortgageeNameAddressLine1 ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "mortgageeNameAddressLine1",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={18}
                      maxLength={36}
                      isInvalid={
                        formValidation["mortgageeNameAddressLine1"]?.isValid == false
                      }
                    />
                    {formValidation["mortgageeNameAddressLine1"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["mortgageeNameAddressLine1"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={4} md={4}>
                  <FloatingLabel
                    controlId="mortgageeNameAddressLine2"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.addressLine2}
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="mortgageeNameAddressLine2"
                      value={currentDocument.mortgageeNameAddressLine2 ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "mortgageeNameAddressLine2",
                          event.currentTarget.value
                        )
                      }
                      tabIndex={19}
                      maxLength={36}
                    />
                  </FloatingLabel>
                </Column>
              </Row>
              <Row>
                <Column lg={3} md={3}>
                  <FloatingLabel
                    controlId="mortgageeNameAddrCity"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.city}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="mortgageeNameAddrCity"
                      value={currentDocument.mortgageeNameAddrCity ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "mortgageeNameAddrCity",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={20}
                      maxLength={23}
                      isInvalid={
                        formValidation["mortgageeNameAddrCity"]?.isValid == false
                      }
                    />
                    {formValidation["mortgageeNameAddrCity"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["mortgageeNameAddrCity"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={5} md={5}>
                  <Select
                    id="mortgageeNameAddrState"
                    controlId="mortgageeNameAddrState"
                    className=""
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.state}
                        {/* <span className="text-danger ms-1">*</span> */}
                      </>
                    }
                    options={statesList}
                    defaultSelected={statesList.filter(
                      (option) =>
                        option.value === currentDocument.mortgageeNameAddrState
                    )}
                    onChange={(values) =>
                      onEntityFieldChange("mortgageeNameAddrState", values[0] as string)
                    }
                    tabIndex={21}
                    isInvalid={
                      formValidation["mortgageeNameAddrState"]?.isValid == false
                    }
                    invalidWarning={
                      formValidation["mortgageeNameAddrState"]?.warningText
                    }
                    isRequired={true}
                  />
                </Column>
                <Column lg={4} md={4}>
                  <FloatingLabel
                    controlId="mortgageeNameAddrZipCode"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.zip}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="mortgageeNameAddrZipCode"
                      value={currentDocument.mortgageeNameAddrZipCode ?? ""}
                      onChange={(event) => {
                        let value = event.currentTarget.value.replace(/[^0-9]/g, "");
                        if (value.length > 5) {
                          value = value.slice(0, 5) + '-' + value.slice(5, 9);
                        }
                        onEntityFieldChange("mortgageeNameAddrZipCode", value);
                      }}
                      required={true}
                      tabIndex={22}
                      isInvalid={
                        formValidation["mortgageeNameAddrZipCode"]?.isValid == false
                      }
                      maxLength={10}
                    />
                    {formValidation["mortgageeNameAddrZipCode"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["mortgageeNameAddrZipCode"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
              </Row>
            </Panel>
            <Panel title={documateLabel.REFI_PROCESSING_LABELS.requestorPanel}>
              <Row>
                <Column lg={5} md={5}>
                  <FloatingLabel
                    controlId="requestorName"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.requestorName}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="requestorName"
                      value={currentDocument.requestorName ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "requestorName",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={23}
                      maxLength={100}
                      isInvalid={
                        formValidation["requestorName"]?.isValid == false
                      }
                    />
                    {formValidation["requestorName"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["requestorName"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
                <Column lg={7} md={7}>
                  <FloatingLabel
                    controlId="requestorEmail"
                    label={
                      <>
                        {documateLabel.REFI_PROCESSING_LABELS.email}
                        <span className="text-danger ms-1">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder=" "
                      name="requestorEmail"
                      value={currentDocument.requestorEmail ?? ""}
                      onChange={(event) =>
                        onEntityFieldChange(
                          "requestorEmail",
                          event.currentTarget.value
                        )
                      }
                      required={true}
                      tabIndex={24}
                      isInvalid={
                        formValidation["requestorEmail"]?.isValid == false
                      }
                    />
                    {formValidation["requestorEmail"]?.isValid == false && (
                      <Form.Control.Feedback type="invalid">
                        {formValidation["requestorEmail"]?.warningText}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Column>
              </Row>
            </Panel>
            {/* {CloseButtonWithDropdownOptions} */}
          </div>
          <div className="doc-view-container">
            <div className="button-container">
              <Button
                className="approve-btn"
                key="filter"
                onClick={() => onApproveDocument(id)}
                tabIndex={25}
                id="approveRefi"
                disabled={isViewOnly}
              >
                <FontAwesomeIcon icon="check" className="me-2" />
                {documateLabel.APPROVE_DOCUMENT}
              </Button>
              <Button
                className="reject-btn"
                key="filter"
                onClick={() => rejectDocument(id)}
                tabIndex={26}
                id="rejectRefi"
                disabled={isViewOnly}
              >
                <FontAwesomeIcon icon="times" className="me-2" />
                {documateLabel.REJECT_DOCUMENT}
              </Button>
              <Button
                className="closeOnly-btn"
                key="filter"
                onClick={() => handleCloseDocument(id)}
                tabIndex={27}
                id="closeDocument"
                disabled={false}
                ref={closeButtonRef}
                onKeyDown={(e) => {
                  if (e.key == "Tab" && !e.shiftKey) {
                    firstControlRef.current.focus();
                    e.preventDefault();
                  }
                }}
                >
                {/* <FontAwesomeIcon icon="times" className="me-2" /> */}
                {documateLabel.CLOSE_DOCUMENT}
                </Button>
            </div>
            {docViewerOpen && (
              <DocViewer
              document={emailPdf}
                scanId={fileName}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default RefiProcessing;
